import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const MerchantBonuses = lazy(() => import('../../container/merchantBonuses'));

function MerchantBonusesRoute() {
  return (
    <Routes>
      <Route path="/" element={<MerchantBonuses />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default MerchantBonusesRoute;
